import { useEffect, useState } from "react"

// FIQ-578: converts a "stuck forever" loading state into an explicit signal.
// Returns true once `active` has remained continuously true for `timeout` ms,
// and resets whenever `active` goes false. Callers use this to swap an
// indefinite spinner for a recovery UI when the underlying queries hang.
// Changing `resetKey` starts a fresh timeout window (used when the user
// clicks "Try again" while the underlying request is still hanging).
export function useLoadingTimeout(active, timeout = 30000, resetKey = 0) {
    const [timedOut, setTimedOut] = useState(false)
    useEffect(configureTimer, [active, timeout, resetKey])
    return active && timedOut

    function configureTimer() {
        setTimedOut(false)
        if (!active) {
            return undefined
        }
        const timer = setTimeout(flagTimedOut, timeout)
        return cancelTimer

        function flagTimedOut() {
            setTimedOut(true)
        }

        function cancelTimer() {
            clearTimeout(timer)
        }
    }
}
